import SbUtils from '../../Utils/SbUtils'

const FullScreenLoader = () => {
    return (
        <div className='sb-fs-loader'>
            <div className='sb-fs-loader-new-logo'>
                { SbUtils.printIcon( 'newLoader', 'sb-fs-loader-new-img') }
            </div>
        </div>
    )
}

export default FullScreenLoader;